import React, { useState, useEffect, useRef } from 'react';
import "../../css/Captcha.css";

const Captcha = ({ onVerify, onExpire, timeout = 120000, regenerateOnError = true }) => {
  const [captchaText, setCaptchaText] = useState('');
  const [userInput, setUserInput] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState('');
  const [timeLeft, setTimeLeft] = useState(Math.floor(timeout / 1000));
  const canvasRef = useRef(null);
  const timerRef = useRef(null);

  // تولید CAPTCHA تصادفی فقط با عملیات جمع
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    
    const text = `${num1} + ${num2}`;
    const answer = (num1 + num2).toString();
    
    return { text, answer };
  };

  // رسم CAPTCHA روی کانواس
  const drawCaptcha = (text) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // پس‌زمینه
    ctx.fillStyle = '#f0f0f0';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // اضافه کردن نویز (خطوط تصادفی)
    for (let i = 0; i < 5; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.strokeStyle = `rgba(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100}, 0.3)`;
      ctx.lineWidth = 1;
      ctx.stroke();
    }
    
    // اضافه کردن نقاط تصادفی
    for (let i = 0; i < 50; i++) {
      ctx.beginPath();
      ctx.arc(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        Math.random() * 2,
        0,
        2 * Math.PI
      );
      ctx.fillStyle = `rgba(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100}, 0.3)`;
      ctx.fill();
    }
    
    // متن CAPTCHA
    const textColor = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100})`;
    ctx.fillStyle = textColor;
    ctx.font = 'bold 24px Arial';
    
    // اعوجاج متن
    const textMetrics = ctx.measureText(text);
    const textWidth = textMetrics.width;
    const startX = (canvas.width - textWidth) / 2;
    
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const charWidth = ctx.measureText(char).width;
      const yOffset = Math.random() * 5 - 2.5;
      const rotation = Math.random() * 0.4 - 0.2;
      
      ctx.save();
      ctx.translate(startX + charWidth * i + charWidth / 2, canvas.height / 2 + yOffset);
      ctx.rotate(rotation);
      ctx.fillText(char, -charWidth / 2, 0);
      ctx.restore();
    }
  };

  // مقداردهی اولیه CAPTCHA
  const initCaptcha = () => {
    const { text, answer } = generateCaptcha();
    setCaptchaText(answer);
    drawCaptcha(text);
    setUserInput('');
    setError('');
    setTimeLeft(Math.floor(timeout / 1000));
    
    // راه‌اندازی تایمر
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    
    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          if (onExpire) onExpire();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // بررسی پاسخ کاربر
  const verifyCaptcha = () => {
    if (userInput === captchaText) {
      setIsVerified(true);
      setError('');
      if (onVerify) onVerify(true);
      clearInterval(timerRef.current);
    } else {
      setError('کد امنیتی نادرست است');
      if (onVerify) onVerify(false);
      
      if (regenerateOnError) {
        initCaptcha();
      }
    }
  };

  // اولین رندر
  useEffect(() => {
    initCaptcha();
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  return (
    <div className="captcha-container">
      <div className="captcha-header">
        <h3>تایید امنیتی</h3>
        <div className="timer">زمان باقی‌مانده: {timeLeft} ثانیه</div>
      </div>
      
      <div className="captcha-body">
        <canvas 
          ref={canvasRef} 
          width="200" 
          height="80" 
          className="captcha-canvas"
        />
        
        <div className="captcha-controls">
          <button 
            type="button" 
            onClick={initCaptcha} 
            className="refresh-button"
            aria-label="بارگذاری مجدد کد امنیتی"
          >
            ↻
          </button>
          
          <input
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            placeholder="جواب را وارد کنید"
            className="captcha-input"
            disabled={isVerified}
          />
          
          <button 
            type="button" 
            onClick={verifyCaptcha} 
            className="verify-button"
            disabled={isVerified}
          >
            تأیید
          </button>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        {isVerified && <div className="success-message">✓ تأیید شد</div>}
      </div>
      
      <div className="captcha-footer">
        <p>لطفا حاصل جمع نمایش داده شده را محاسبه کنید</p>
      </div>
    </div>
  );
};

export default Captcha;